/* eslint-disable */
import { useState } from 'react';
import { userService } from '../services/userService';

import {
	UpdateProfileRequest,
	UpdateUserRoleRequest,
	CoachPerformanceStats,
} from '../types/user';

export function useCoachPerformance() {
	const [performance, setPerformance] =
		useState<CoachPerformanceStats | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchCoachPerformance = async (coachId: string) => {
		if (!coachId) return;

		setLoading(true);
		setError(null);

		try {
			
			
			const response = await userService.getCoachPerformanceStats(coachId);

setPerformance(response.data);
		} catch (err: any) {
			console.error('Error fetching coach performance:', err);
			setError(err.message || 'Failed to fetch coach performance');
		} finally {
			setLoading(false);
		}
	};

	return {
		performance,
		loading,
		error,
		fetchCoachPerformance,
	};
}
